import React from "react";
import classnames from "classnames";
import { IComparisonCard } from "../../types/IComparisonCard";
import { Heading } from "../Heading";
import { RichText } from "../RichText";
import "./styles.scss";

interface IProps extends IComparisonCard {
  classNames?: string;
  parentBgColour: string;
}

const ComparisonCard = (props: IProps) => {
  const {
    title, items, classNames, parentBgColour, headingType,
  } = props;

  const titleContainerClasses = classnames("comparisonCard__titleContainer", {
    "comparisonCard__titleContainer--grey": parentBgColour === "white",
  });

  return (
    <div className={`comparisonCard ${classNames}`}>
      <div className={titleContainerClasses}>
        <Heading className="comparisonCard__title" type={headingType}>
          {title}
        </Heading>
      </div>
      <div className="comparisonCard__contentContainer">
        {items.map((item, index) => (
          <div key={index} className="comparisonCard__item">
            <p className="comparisonCard--boldText">{item.title}</p>
            {item.content && (
              <RichText
                className="comparisonCard__content"
                content={item.content}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export { ComparisonCard, IProps };
